<div class="sales-order-line-items-purchase-order-dialog">
  <div class="lum-c-sales-order-line-items-purchase-order-dialog__header">
    <h2 mat-dialog-title>Purchase Order Options</h2>
  </div>

  <div class="lum-c-sales-order-line-items-purchase-order-dialog__content">
    <form [formGroup]="form">
      <mat-checkbox
        class="lum-checkbox mt-3"
        formControlName="combineIdenticalSkus"
      >
        Combine identical SKUs into the same line
      </mat-checkbox>

      <div class="form-group mt-4">
        <div class="lum-label">Alternate IDs</div>
        <lum-alternate-ids
          [formArray]="alternateIdsFormArray"
          [label]="'Alternate IDs'"
          [placeholder]="'Press enter to add alternate id...'"
        ></lum-alternate-ids>
      </div>
    </form>
  </div>

  <mat-dialog-actions align="end">
    <button class="lum-button lum-button--tertiary mr-2" mat-dialog-close>
      Cancel
    </button>
    <button class="lum-button" (click)="onSubmit()" cdkFocusInitial>
      Create Purchase Order
    </button>
  </mat-dialog-actions>
</div>
